"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useToast } from "@/components/ui/use-toast";

import { postRegistry } from "@/services/registry";

import { queryKeys } from "../query-key";

import type { House } from "@/types";

interface Props {
  property: House;
  registryText: string;
}

export const usePostRegistry = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  const mutation = useMutation({
    mutationFn: async ({ property, registryText }: Props) =>
      await postRegistry(property, registryText),
    onSuccess: async (data) => {
      await queryClient.invalidateQueries({
        queryKey: queryKeys.analyzes,
      });
      await queryClient.invalidateQueries({
        queryKey: queryKeys.analyze({
          id: data.registro_de_matricula.numero_do_leilao,
          field: "numero_do_leilao",
        }),
      });
      await queryClient.invalidateQueries({
        queryKey: queryKeys.onboarding,
      });
    },
    onError: (error) => {
      toast({
        title: "Erro ao salvar matrícula",
        description:
          error instanceof Error
            ? error.message
            : "Ocorreu um erro ao salvar a matrícula",
        variant: "destructive",
      });
    },
  });

  return mutation;
};
